import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget, mdsLazyProto } from 'dojo/_base/declare';
import template from './MainCatalogSelectV2.html?raw';
import { MainCatalogTypes, MainCatalogs_Classes } from "../_loadingHelpers/MainCatalogTypes";
import SearchSelect from '../../moreCore/UI/SearchSelect/SearchSelect';
import {                                
    ActivityStatusEditor,               // *************************************************************
    BookingStatusEditor,                // !! WICHTIG !!
    DutyTypeEditor,                     // Verwenden Sie MainCatalogEditorTools für alle Editor Importe, 
    FunctionalGroupEditor,              // um Probleme mit zirkulärer Abhängigkeit zu vermeiden
    FunctionalMainGroupEditor,          // *************************************************************
    VenueEditor,
    RoomEditor,
    ServiceCategoriesEditor,
    ServicePackagesEditor,
    EvCategories_1_Editor,
    EvCategories_2_Editor,
    AddressCategoriesEditorV2,
    AddressMainCategoriesEditor,
    FileCategoryEditor,
    EvTaskDescriptEditor,
    EvTaskDescriptGroupEditor,
    EvServiceEditor,
    ProfessionsEditor,
    ActivityStatusEditorV2,
    AddressMainCategoriesEditorV2,
    EvTaskDescriptGroupEditorV2,
    FunctionalMainGroupEditorV2,
    VenueEditorV2,
    EvProcessGroupCategorieEditor,
    TodoCategoryEditor,
    RelationGroupsEditor,
    ResourceMainGroupEditor
} from './MainCatalogEditorTools';
import MainCatalogsEditorBaseV2 from './MainCatalogsEditorBaseV2';
import GenericDialog from '../../moreCore/UI/GenericDialog/GenericDialog';




class MainCatalogSelectV2 extends compose(_WidgetBaseSP) {
    templateString: any = template;

    value: string = null;
    label: string = "";

    showEditForm: boolean = false;
    isFormOpened: boolean = false;
    private useEditButton: boolean = false;

    catalogClass: MainCatalogs_Classes;
    editForm: MdsLax<InstanceType<typeof MainCatalogsEditorBaseV2>>;

    editFormMainHeader: HTMLElement;

    catalogLabelContainer: HTMLElement;
    catalogEditContainer: HTMLElement;
    editFrame: HTMLElement;
    catalogActionContainer: HTMLElement;

    catalogButtonShowEdit: HTMLButtonElement;
    catalogButtonAddNew: HTMLButtonElement;

    catalogEditErrorContainer: HTMLElement;
    catalogEditErrorMessage: HTMLElement;

    catalogSearchSelect: MdsLax<InstanceType<typeof SearchSelect>>;

    isReadonly: boolean = false;

    setReadonly() {
        this.isReadonly = true;

        this.catalogSearchSelect._setReadonlyAttr(true);
        this.hideNode(this.catalogActionContainer, true);
        if (this.catalogActionContainer) this.UiModder.domConstruct.destroy(this.catalogActionContainer);
    }


    loadListInfo(id?: string): void {
            
        if (!id) this.catalogSearchSelect.loadListValues();
        else this.catalogSearchSelect.loadListValues(id, true);

        //this.UiModder.domClass.add(this.catalogSearchSelect.scrollContainer, "w3-2018-coconut-milk");
    }

    setLabel(label: string): void {

        this.label = label;
        this.catalogLabelContainer.innerHTML = this.label;

        label ? this.UiModder.domClass.remove(this.catalogLabelContainer, "w3-hide") : this.UiModder.domClass.add(this.catalogLabelContainer, "w3-hide");  
    }

    setEditButtonVisibility(visible: boolean = true) {
        this.useEditButton = visible === true;

        this.UiModder.domClass.toggle(this.catalogButtonShowEdit, "w3-hide", this.useEditButton != true);
    }

    setCatalog(catalogClass: MainCatalogs_Classes, label: string, presetValue?: string, labelAttribute?: string): void {

        //if (this.editForm) this.editForm.destroy();
        //nach dem Speichern war ein Fehler aufgetreten, wenn kein Editor oder ein Tab geöffnet war - also wird es auf Null zurückgesetzt
        this.editForm = null;

        this.catalogClass = catalogClass;
        this.setLabel(label);
        if (presetValue) this.value = presetValue;

        this.setupSearchSelect(labelAttribute);
        this.setUpEventListeners();

        if (presetValue) {
            this.loadListInfo(presetValue);
        }
    }

    private setupSearchSelect(labelAttribute?: string) {
        this.catalogSearchSelect.setRequestParameter("entityClass", this.catalogClass);
        this.catalogSearchSelect.setUrl("MainCatalogsEditor/LoadMainCatalogSelect");
        this.catalogSearchSelect.labelAttribute = labelAttribute ? labelAttribute : "$Displayname";
    }

    private createNewEditor(data?: object) {
        switch (this.catalogClass) {
            case MainCatalogs_Classes.EvActivityStatus:
                this.editForm = new ActivityStatusEditorV2();
                this.catalogSearchSelect.setOuterPlaceholder("MainCatalogsEditor_Placeholder_ActivityStatus");
                this.catalogSearchSelect.labelAttribute = "gDisp_1";
                this.label = this.translate("General_Label_EvActivityStatus");
                break;
            case MainCatalogs_Classes.AddressCategory:
                this.editForm = new AddressCategoriesEditorV2();
                this.catalogSearchSelect.setPlaceholder("MainCatalogsEditor_Placeholder_AddressCategories");
                this.catalogSearchSelect.setOuterPlaceholder("MainCatalogsEditor_Placeholder_AddressCategories");
                this.catalogSearchSelect.labelAttribute = "description";
                this.label = this.translate("General_Label_AddressCategory");
                break;
            case MainCatalogs_Classes.AddressMainCategory:
                this.editForm = new AddressMainCategoriesEditorV2();
                this.catalogSearchSelect.setPlaceholder("MainCatalogsEditor_Placeholder_AddressMainCategories");
                this.catalogSearchSelect.setOuterPlaceholder("MainCatalogsEditor_Placeholder_AddressMainCategories");
                this.catalogSearchSelect.labelAttribute = "description";
                this.label = this.translate("General_Label_AddressMainCategory");
                break;
            case MainCatalogs_Classes.EvTaskDescriptGroup:
                this.editForm = new EvTaskDescriptGroupEditorV2();
                this.catalogSearchSelect.setPlaceholder("MainCatalogsEditor_Placeholder_EvTaskDescriptGroup");
                this.catalogSearchSelect.setOuterPlaceholder("MainCatalogsEditor_Placeholder_EvTaskDescriptGroup");
                this.catalogSearchSelect.labelAttribute = "description";
                this.label = this.translate("General_Label_EvTaskDescriptGroup");
                break;
            case MainCatalogs_Classes.FunctionalMainGroup:
                this.editForm = new FunctionalMainGroupEditorV2();
                this.catalogSearchSelect.setPlaceholder("MainCatalogsEditor_Placeholder_FunctionalMainGroup");
                this.catalogSearchSelect.setOuterPlaceholder("MainCatalogsEditor_Placeholder_FunctionalMainGroup");
                this.catalogSearchSelect.labelAttribute = "description";
                this.label = this.translate("General_Label_FunctionalMainGroup");
                break;
            case MainCatalogs_Classes.Venues:
                this.editForm = new VenueEditorV2();
                this.catalogSearchSelect.setPlaceholder("MainCatalogsEditor_Placeholder_Venues");
                this.catalogSearchSelect.setOuterPlaceholder("MainCatalogsEditor_Placeholder_Venues");
                this.catalogSearchSelect.labelAttribute = "description";
                this.label = this.translate("General_Label_Venue");
                break;
            case MainCatalogs_Classes.EvProcessGroupCategorie:
                this.editForm = new EvProcessGroupCategorieEditor();
                this.catalogSearchSelect.setPlaceholder("MainCatalogsEditor_Placeholder_EvProcessGroupCategorie");
                this.catalogSearchSelect.setOuterPlaceholder("MainCatalogsEditor_Placeholder_EvProcessGroupCategorie");
                this.catalogSearchSelect.labelAttribute = "description";
                this.label = this.translate("General_Label_EvProcessGroupCategorie");
                break;
            case MainCatalogs_Classes.TodoCategory:
                this.editForm = new TodoCategoryEditor();
                this.catalogSearchSelect.setPlaceholder("MainCatalogsEditor_Placeholder_TodoCategory");
                this.catalogSearchSelect.setOuterPlaceholder("MainCatalogsEditor_Placeholder_TodoCategory");
                this.catalogSearchSelect.labelAttribute = "description";
                this.label = this.translate("General_Label_TodoCategory");
                break;
            case MainCatalogs_Classes.RelationGroups:
                this.editForm = new RelationGroupsEditor();
                this.catalogSearchSelect.setPlaceholder("MainCatalogsEditor_Placeholder_RelationGroups");
                this.catalogSearchSelect.setOuterPlaceholder("MainCatalogsEditor_Placeholder_RelationGroups");
                this.catalogSearchSelect.labelAttribute = "description";
                this.label = this.translate("General_Label_RelationGroups");
                break;
            case MainCatalogs_Classes.ResourceMainGroup:
                this.editForm = new ResourceMainGroupEditor();
                this.catalogSearchSelect.setPlaceholder("MainCatalogsEditor_Placeholder_ResourceMainGroup");
                this.catalogSearchSelect.setOuterPlaceholder("MainCatalogsEditor_Placeholder_ResourceMainGroup");
                this.catalogSearchSelect.labelAttribute = "description";
                this.label = this.translate("General_Label_ResourceMainGroup");

        }

        this.editForm.on("deleted", lang.hitch(this, this._onEntityDeleted));
        this.editForm.on("CatalogEntityData_Save", lang.hitch(this, this._reloadSearchSelect));
    }

    private _onEntityDeleted(deletedEntity: { ID: string }) {

        if (deletedEntity.ID === this.catalogSearchSelect.getValue()) this.catalogSearchSelect.setValue(null);

        this._reloadSearchSelect();
    }
    private _reloadSearchSelect(): void {
        var currentValue = this.catalogSearchSelect.getValue();
        this.catalogSearchSelect.loadListValues(currentValue, true);
    }

    setUpEventListeners(): void {

        //on(this.editForm, "CatalogEntityData_Response", lang.hitch(this, this._onEvent_Response));
        //on(this.editForm, "CatalogEntityData_Close", lang.hitch(this, this._onEvent_Close));
        //on(this.editForm, "CatalogEntityData_Save", lang.hitch(this, this._onEvent_Save));
        //on(this.editForm, "CatalogEntityData_Error", lang.hitch(this, this._onEvent_Error));
        //on(this.editForm, "CatalogEntityData_NoId", lang.hitch(this, this._onEvent_NoId));
    }

    _onEvent_NoId(): void {

        this.StandbyStop();
        this.UiModder.domClass.add(this.catalogEditContainer, "w3-hide");
    }

    _onEvent_Save(id: string) {

        this.loadListInfo(id);
        this.value = id;
        this.emitChangeEvent();
        this.UiModder.domClass.remove(this.catalogButtonAddNew, "w3-disabled");
    }

    _onEvent_Response(): void {
        this.UiModder.domClass.remove(this.catalogEditContainer, "w3-hide");
        this.UiModder.domClass.remove(this.catalogSearchSelect.domNode, "ego_animated_progressBar");
        this.isFormOpened = true;
        this.StandbyStop();
    }

    _onEvent_Close(): void {

        this._showErrorMessage(false);

        this.UiModder.domClass.add(this.catalogEditContainer, "w3-hide");
        this.UiModder.domClass.remove(this.catalogButtonAddNew, "w3-disabled");
        this.isFormOpened = false;

        // Select ausleeren
        this.catalogSearchSelect.setValue(null);
    }

    _onEvent_Error(msg: string) {

        this.StandbyStop();
        this.loadListInfo();
        this._showErrorMessage(true, msg);
    }

    _onClickButtonShowEdit(): void {
        var data = this.catalogSearchSelect.getValue(true);
        this.createNewEditor();



        if (this.createNewTabbedContent({
            enableClosing: true,
            name: data.ID,
            sidebarEntryName: "entityID",
            label: this.translations["MainCatalogsEditor_Form_MainHeader_New"],
            widget: this.editForm,
            groupLabel: this.label,
            targetContainerName: this.getTabContainerName()
        }, true, true) == true) {
            // Tab öffnen hat funktioniert
        } else {
            let dlg = new GenericDialog();
            dlg.closeOnEnter = false;
            dlg.closeOnEscape = false;
            dlg._setTopCloseBtnAttr(true);
            dlg.keepOpen = true;
            //dlg.setUserdefinedButton(this.translations["AddressWizard__done"],
            //    null,
            //    lang.hitch(this, this._onWizardDone, dlg, this.editor))


            //dlg.enableContentOverflow(true);

            dlg.show(this.editForm,
                this.title,
                null,
                null,
                "saveclose",
                lang.hitch(this, null, dlg, null));
        }

        this.editForm.setIsNew(false);
        this.editForm.setData(data);


    }

    _onClickButtonAddNew(): void {
        this.createNewEditor();

        if (this.createNewTabbedContent({
            enableClosing: true,
            name: "newEditor_" + this.catalogClass + "_" + Math.random() * 100000000000,
            sidebarEntryName: "entityID",
            label: `${this.translate("General_New")}: ${this.label}`,
            widget: this.editForm,
            groupLabel: this.label,
            targetContainerName: this.getTabContainerName()
        }, true, true) == true) {
            // Tab öffnen hat funktioniert
        } else {
            let dlg = new GenericDialog();
            dlg.closeOnEnter = false;
            dlg.closeOnEscape = false;
            dlg._setTopCloseBtnAttr(true);
            dlg.keepOpen = true;
            //dlg.setUserdefinedButton(this.translations["AddressWizard__done"],
            //    null,
            //    lang.hitch(this, this._onWizardDone, dlg, this.editor))


            //dlg.enableContentOverflow(true);

            dlg.show(this.editForm,
                this.title,
                null,
                null,
                "saveclose",
                lang.hitch(this, null, dlg, null));
        }

        this.editForm.setStartupState("ready");
    }

    _changeEditorMainHeader(header: "new" | "edit"): void {

        switch (header) {
            case "new":
                this.editFormMainHeader.innerHTML = this.translations["MainCatalogsEditor_Form_MainHeader_New"];
                break;
            case "edit":
                this.editFormMainHeader.innerHTML = this.translations["MainCatalogsEditor_Form_MainHeader_Edit"];
                break;
        }
    }


    _onChangeCatalogSearchSelect(e: Event): void {
        var mainCategory = this.catalogSearchSelect.getValue();
        if (mainCategory) {
            this.hideNode(this.catalogButtonShowEdit, false);
        } else {
            this.hideNode(this.catalogButtonShowEdit, true);
        }
        this.value = mainCategory;
        this.emitChangeEvent();
    }

    _showErrorMessage(bool: boolean, msg?: string) {

        if (bool) {

            this.UiModder.domClass.remove(this.catalogEditErrorContainer, "w3-hide");
            msg ? this.catalogEditErrorMessage.innerHTML = msg : this.catalogEditErrorMessage.innerHTML = "...error occured";
        } else {

            this.UiModder.domClass.add(this.catalogEditErrorContainer, "w3-hide");
            this.catalogEditErrorMessage.innerHTML = "";
        }
    }

    emitChangeEvent(): void {
        this.emit("change");
    }

    setValue(value: string): void {

        this.catalogSearchSelect.setValue(value);
    }

    getValue(): string {
        return this.value;
    }

    private _onSearchSelectLoaded(): void {
        var currentValue = this.catalogSearchSelect.getValue();

        if (currentValue) {
            this.hideNode(this.catalogButtonShowEdit, false);
        } else {
            this.hideNode(this.catalogButtonShowEdit, true);
        }
    }

    //BASE
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.catalogSearchSelect.on("loaded", lang.hitch(this, this._onSearchSelectLoaded));
    }
    startup(): void {
        super.startup.apply(this, arguments as any);

        this.loadListInfo(this.value);
    }
}

mdsLazyProto(MainCatalogSelectV2.prototype, {
  catalogSearchSelect: () => (new SearchSelect()),
});
export default mdsWidget(MainCatalogSelectV2);